import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {PbxAccountsService as PbxAccountsApiService} from '../../../api/services/pbx-accounts.service';
import {catchError, finalize} from 'rxjs/operators';
import {PbxAccountModel} from '../../../api/models/pbx-account-model';
import {PbxAccountListRequest} from '../../../api/models/pbx-account-list-request';
import {PbxAccountGridResponse} from '../../../api/models/pbx-account-grid-response';


export class PbxAccountsDatasource implements DataSource<PbxAccountModel> {

  constructor(private pbxApiService: PbxAccountsApiService) {
  }

  private dataSubject = new BehaviorSubject<PbxAccountModel[]>([]);
  private dataTotalSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  public dataCount$ = this.dataTotalSubject.asObservable();

  connect(collectionViewer: CollectionViewer): Observable<PbxAccountModel[] | ReadonlyArray<PbxAccountModel>> {
    console.log('Connecting data source');
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    console.log('Disconnecting data source');
    this.dataSubject.complete();
    this.loadingSubject.complete();
    this.dataTotalSubject.complete();
  }

  public currentPageData(): PbxAccountModel[] {
    return this.dataSubject.getValue();
  }

  public queryData(state: PbxAccountListRequest): void {
    console.log('query phone numbers');
    this.loadingSubject.next(true);

    // todo: this.callLogAggregates = {};
    this.pbxApiService
      .pbxAccountsGetList({body: state})
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response: PbxAccountGridResponse) => {
        this.dataTotalSubject.next(response.total);
        this.dataSubject.next(response.data);
      } );
  }
}
